module.exports = __webpack_public_path__ + "img/03 venus.d942947e.png";